export const HAPPY = 'happy';
export const EXCITED = 'excited';
export const CALM = 'calm';
export const ANNOYED = 'nervous'; //changed
export const CONFIDENT = 'tired'; //changed
export const SCARED = 'sad'; //changed
export const ANGRY = 'bored'; //changed
export const WORRIED = 'worried';
export const ALLMOOD = 'All';
